export default __webpack_public_path__ + "static/media/newslide1.b10c271b.jpg";